<template>
    <div id="single-report-view" :class="{'embedded-report': embeddedVersion}">
        <report
            :reportId="$route.params.id"
            :miniMode="true"
            ref="report"
        ></report>
    </div>
</template>

<script>
import Report from '@/components/Report';
export default {
    name: 'ReportEmbed',
    components: {
        Report
    },
    data () {
        return {
            embeddedVersion: this.$route.query.embeddedVersion
        };
    },
    mounted () {
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
